/* eslint-disable */
export default {
  'CreditCardExpired': 10,
  'IOExceeded': 20,
  'PaymentInformationMissing': 30,
  'InvalidFinancialStatusOther': 40,
  'MigrationPaused': 45,
  'CampaignDeleted': 48,
  'CampaignSuspended': 49,
  'CampaignBudgetPaused': 50,
  'AdGroupExpired': 60,
  'AdGroupDraft': 62,
  'AdGroupDeleted': 63,
  'CamAssetRejected': 64,
  'CamAssetDeleted': 66,
  'AdGroupTargetingTooNarrow': 67,
  'EditorialRejected': 70,
  'EditorialUnderAppeal': 75,
  'UrlInvalid': 76,
  'ApplicationNotFound': 77,
  'ApplicationDestinationUrlMismatch': 78,
  'EditorialPending': 80,
  'AssociationDeleted': 85,
  'CampaignUserPaused': 90,
  'AdGroupPrivacyPending': 91,
  'AdGroupUserPaused': 100,
  'AdUserPaused': 110,
  'KeywordMatchTypeAdGroupMediumCombinationInvalid': 115,
  'KeywordUserPaused': 120,
  'NegativeKeywordConflicts': 130,
  'EditorialApprovedLimited': 200,
  'LowSupply': 300,
  'LowQuality': 400,
  'BidBelowFirstPageBid': 500,
  'Incomplete': 1000,
  'BudgetSuggestions': 1001,
  'InlineOpportunity': 1060,
  'GeoCodingIncomplete': 1101,
  'ProductTargetUserPaused': 1102,
  'AdExtensionNotPresent': 1103,
  'AdExtensionDeleted': 1104,
  'AdExtensionAssociationDeleted': 1105,
  'StoreIdNotAssociated': 1106,
  'AdGroupAudienceAssociationPaused': 1107,
  'AdGroupAudienceAssociationExcluded': 1108,
  'AdNotPresent': 1200,
  'AdNotActive': 1201,
  'ApplicationDestinationUrlValidationIncomplete': 1252,
  'Eligible': 2147483647
};

